<template>
    <a class="plugin-slider-video-item swiper-slide"
       v-bind:href="link"
    >
        <div class="plugin-slider-video-item__media">
            <img v-bind:src="image" alt="" />
            <div class="plugin-slider-video-item__media-icon">
                <icon name="play-button" width="40" height="40" />
            </div>
        </div>
        <div class="plugin-slider-video-item__text"
             v-bind:class="{ _dark: isDark }"
             v-text="text"
        />
    </a>
</template>

<script>
export default {
    name: 'plugin-slider-video-item',
    props: {
        text: {
            type: String,
        },
        link: {
            type: String,
        },
        image: {
            type: String,
        },
        isDark: {
            type: Boolean,
            default: false,
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({

    }),
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-slider-video-item {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: 374px;
    overflow: hidden;

    &__media {
        position: relative;
        width: 100%;
        // height: 210px;
        aspect-ratio: 374 / 210;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border: 1px solid white;
        border-radius: @border-radius-xll;
        overflow: hidden;
        img {
            width: 100%;
            filter: grayscale(1);
            transition: filter 0.3s ease;
            cursor: pointer;
        }
        img:hover {
            filter: grayscale(0);
        }
        &-icon {
            position: absolute;
            right: 10px;
            bottom: 10px;
            width: 40px;
            height: 40px;
            color: @color-primary;
            z-index: 10;
            cursor: pointer;
        }
    }
    &__text {
        .typography-small();

        font-weight: bold;
        color: @color-gray-darker;
        &._dark {
            color: @color-gray-lightest;
        }
    }
    @media @media-md-down {
        max-width: 100%;

        &__media {
            img {
                filter: grayscale(0);
            }
        }
        &__text {
            .typography-heading();
        }
    }
}
</style>
